// Data URI em nova aba e bloqueado por varios navegadores; object URL de blob nao e.
export function base64ParaBlobUrl(base64: string): string {
  const puro = base64.includes(',') ? base64.slice(base64.indexOf(',') + 1) : base64;
  const binario = atob(puro);

  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) {
    bytes[i] = binario.charCodeAt(i);
  }

  return URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
}
